import { render, staticRenderFns } from "./ReView.vue?vue&type=template&id=18bec3a4&scoped=true"
import script from "./ReView.vue?vue&type=script&lang=js"
export * from "./ReView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bec3a4",
  null
  
)

export default component.exports